module.exports = new __parcel__URL__("raiders-of-the-lost-ark.9e445228.jpg").toString();